const finiteNumber = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const roundedBadgePercentageValue = value => {
  const numeric = finiteNumber(value);
  return Math.round((numeric + Number.EPSILON) * 10) / 10;
};

export const formatBadgePercentage = value => `${roundedBadgePercentageValue(value).toFixed(1)}%`;

export const roundedBadgeStageThreshold = value => Math.round(finiteNumber(value));

const replacePercentages = (text, transform) => String(text ?? '').replace(
  /(-?\d+(?:\.\d+)?)%/g,
  (_match, value) => `${transform(Number(value)).toFixed(1)}%`
);

export const formatBadgePercentageText = text => replacePercentages(text, roundedBadgePercentageValue);

export const formatBadgeStagePercentageText = text => replacePercentages(text, roundedBadgeStageThreshold);
